import React, { useState } from "react";
import { FaSearch, FaFilePdf, FaFileCsv, FaFileExcel } from "react-icons/fa";
import "./ListaAlunos.css";

const FiltroAlunos = ({ filtroNome, setFiltroNome, filtroClasse, setFiltroClasse, onExportar }) => {
  return (
    <div className="filtro-nome">
      <FaSearch className="icone-pesquisa" />
      <input
        type="text"
        placeholder="Buscar por nome ou código"
        value={filtroNome}
        onChange={(e) => setFiltroNome(e.target.value)}
      />
      <select value={filtroClasse} onChange={(e) => setFiltroClasse(e.target.value)}>
        <option value="">Todas as Classes</option>
        {[...Array(12)].map((_, i) => (
          <option key={i + 1} value={`${i + 1}ª Classe`}>{i + 1}ª Classe</option>
        ))}
      </select>

      <div className="btn-export-container" style={{ display: "flex", gap: "10px" }}>
  <button className="btn-pdf" onClick={() => onExportar("pdf")}>
    <FaFilePdf /> PDF
  </button>

  <button className="btn-excel" onClick={() => onExportar("excel")}>
    <FaFileExcel /> Excel
  </button>

  <button className="btn-csv" onClick={() => onExportar("csv")}>
    <FaFileCsv /> CSV
  </button>
</div>

    </div>
  );
};

export default FiltroAlunos;
